import { Injectable } from '@angular/core';

declare let localStorage: any;

const AUTH_TOKEN_KEY = 'tenthousandcoffees_token';

@Injectable()
export class AuthService {
  public isAuthenticated(): boolean {
    if (!localStorage) {
      return false;
    }

    return !!localStorage.getItem(AUTH_TOKEN_KEY);
  }
}
